import React, { useState, useEffect } from "react";

/* eslint import/no-webpack-loader-syntax: off */
import MultiplyIcon from "-!svg-react-loader!../../../../../client/src/icons/multiply.svg";

import css from "./calculator.css";

const Calculator = ({ onSendButtonClick }) => {
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [unit, setUnit] = useState("inch");

  const minHeight = unit === "cm" ? 10 : 4;
  const maxHeight = unit === "cm" ? 150 : 59;
  const minWidth = unit === "cm" ? 10 : 4;
  const maxWidth = unit === "cm" ? 150 : 59;

  const scrollToElement = () => {
    const formattedHeight =
      unit === "inch" ? `${height} inches` : `${height} CM`;
    const formattedWidth = unit === "inch" ? `${width} inches` : `${width} CM`;
    onSendButtonClick(formattedHeight, formattedWidth, totalPrice);
    const elem = document.getElementById("send-us-message");
    if (elem) {
      elem.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  };

  const handleUnitChange = () => {
    setUnit(unit === "inch" ? "cm" : "inch");
  };

  const calculateResult = () => {
    let parsedHeight = parseFloat(height);
    let parsedWidth = parseFloat(width);

    if (isNaN(parsedHeight) || isNaN(parsedWidth)) {
      return 0;
    }
    if (
      parsedHeight < (unit === "cm" ? minHeight : minHeight) ||
      parsedHeight > (unit === "cm" ? maxHeight : maxHeight) ||
      parsedWidth < (unit === "cm" ? minWidth : minWidth) ||
      parsedWidth > (unit === "cm" ? maxWidth : maxWidth)
    ) {
      return 0;
    }
    if (unit === "cm" && parsedHeight < 10 && parsedWidth < 10) {
      return 0;
    }
    if (unit === "cm") {
      parsedHeight /= 2.54;
      parsedWidth /= 2.54;
    }
    parsedHeight = Math.max(minHeight, Math.min(parsedHeight, maxHeight));
    parsedWidth = Math.max(minWidth, Math.min(parsedWidth, maxWidth));
    const outerLength = ((parsedHeight + parsedWidth) * 2) / 12;
    const wire = 6.0;
    const unitPrice = 4.7;
    const unitPricePerFootRunOfWoodbar = 3.1;
    const laborTable = [
      { min: 0, max: 5, charge: 15.5 },
      { min: 5.01, max: 6, charge: 20.5 },
      { min: 6.01, max: 7, charge: 25.5 },
      { min: 7.01, max: 8, charge: 31.5 },
      { min: 8.01, max: 10, charge: 36.5 },
      { min: 10.01, max: 12, charge: 41.5 },
      { min: 12.01, max: 14, charge: 52 },
      { min: 14.01, max: 16, charge: 67 },
      { min: 16.01, max: 18, charge: 82 },
      { min: 18.01, max: 20, charge: 103 },
      { min: 20.01, max: 22, charge: 113 },
      { min: 22.01, max: 24, charge: 123 },
      { min: 24.01, max: 26, charge: 153 },
      { min: 26.01, max: 28, charge: 153 },
      { min: 28.01, max: 30, charge: 183 },
      { min: 30.01, max: 32, charge: 183 },
      { min: 32.01, max: 36, charge: 205 },
      { min: 36.01, max: 40, charge: 255 },
      { min: 40.01, max: 45, charge: 305 },
    ];

    const matchedRange = laborTable.find(
      (range) => outerLength >= range.min && outerLength <= range.max
    );

    const laborCharge = matchedRange ? matchedRange.charge : 0;

    const totalPrice =
      (outerLength * unitPrice +
        ((parsedHeight / 25) * (parsedWidth / 12) +
          (parsedWidth / 25) * (parsedHeight / 12)) *
          unitPricePerFootRunOfWoodbar +
        wire +
        laborCharge) *
      1.08;

    return Math.ceil(totalPrice);
  };
  const isValidInput = () => {
    let parsedHeight = parseFloat(height);
    let parsedWidth = parseFloat(width);

    let minHeightValue = unit === "cm" ? 10 : 4;
    let minWidthValue = unit === "cm" ? 10 : 4;
    let maxHeightValue = unit === "cm" ? 150 : 59;
    let maxWidthValue = unit === "cm" ? 150 : 59;

    return (
      parsedHeight < minHeightValue ||
      parsedHeight > maxHeightValue ||
      parsedWidth < minWidthValue ||
      parsedWidth > maxWidthValue
    );
  };

  const handleKeyPress = (event) => {
    const forbiddenChars = ["+", "-", "*", "/", "=", "e"];
    if (forbiddenChars.includes(event.key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const newTotalPrice = calculateResult();
    setTotalPrice(newTotalPrice);
  }, [height, width, unit]);

  return (
    <div className="canvas__calculate--wrapper">
      <div className="canvas__calculate__content">
        <h2>Calculate your canvas stretching cost online</h2>
        <p>
          Input the height and width of your canvas to get an online quote for
          stretching. Please note that final pricing would always be determined
          after physical inspection and measurement on our side.
        </p>
      </div>
      <div className="calculator--wrapper">
        <div className="calculator__switc--wrap">
          Inches
          <label className="calculator__switch">
            <input
              type="checkbox"
              checked={unit === "cm"}
              onChange={handleUnitChange}
            />
            <span className="calculator__slider"></span>
          </label>
          CM
        </div>
        <div className="calculator__main">
          <div className="calculator__input">
            <label>
              Height
              <input
                type="number"
                value={height}
                inputMode="numeric"
                pattern="[0-9]*"
                min="0"
                placeholder="Height"
                onKeyPress={handleKeyPress}
                onChange={(e) => setHeight(e.target.value)}
              />
              {isValidInput() && (
                <span className="input-message">
                  Min: {unit === "cm" ? "10" : "4"} Max:{" "}
                  {unit === "cm" ? "150" : "59"}
                </span>
              )}
            </label>
          </div>
          <div className="calculator__input__icon">
            <MultiplyIcon />
          </div>
          <div className="calculator__input">
            <label>
              Width
              <input
                type="number"
                value={width}
                inputMode="numeric"
                pattern="[0-9]*"
                min="0"
                placeholder="Width"
                onKeyPress={handleKeyPress}
                onChange={(e) => setWidth(e.target.value)}
              />
              {isValidInput() && (
                <span className="input-message">
                  Min: {unit === "cm" ? "10" : "4"} Max:{" "}
                  {unit === "cm" ? "150" : "59"}
                </span>
              )}
            </label>
          </div>
        </div>
        <div className="calculate__total">
          Total <span>${totalPrice}</span>
        </div>
        <button className="calculate__btn" onClick={scrollToElement}>
          Send to us
        </button>
      </div>
    </div>
  );
};

export default Calculator;



// WEBPACK FOOTER //
// ./src/new-components/templates/calculator/calculator.jsx